import { useEffect, useRef, useState } from 'react';

export function useQuestionMarkedForm() {
  const formRef = useRef<HTMLDivElement | null>(null);
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  const [openForm, setOpenForm] = useState<boolean>(false);

  const openFormHandler = () => {
    setOpenForm(true);
  };
  const closeFormHandler = () => {
    setOpenForm(false);
    wrapperRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  useEffect(() => {
    if (!openForm) return;
    const t = setTimeout(() => {
      formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
    return () => clearTimeout(t);
  }, [openForm]);

  return {
    formRef,
    wrapperRef,
    openForm,
    setOpenForm,
    openFormHandler,
    closeFormHandler,
  };
}
